import Angie from "~/utils/angie";

export const param = (obj) => {
  if (typeof obj !== `object`) {
    return ``;
  }

  const filterTypes = [`string`, `number`, `boolean`];

  const result = Object.keys(obj).reduce((a, k) => {
    let value = obj[k];

    if (typeof value === `string`) {
      value = value.trim();
      value = value.length ? value : undefined;
    }

    if (filterTypes.indexOf(typeof value) > -1 || Array.isArray(value)) {
      a.push(`${encodeURIComponent(k)}=${encodeURIComponent(value)}`);
    }

    return a;
  }, []);

  return result.join(`&`);
};

export const getUrlWithoutParams = (url) => {
  return url.split("?")[0];
};

export const isInternalLink = (link = "", domainCheck = false) => {
  let isInternal = link.includes(Angie.root_url);

  if (!isInternal && domainCheck) {
    isInternal = link.includes(Angie.activecollab_url);
  }
  return isInternal;
};

export const isUrlValid = (url) =>
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,63}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/.test(url);
